import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyD2iw6uYcts9CAC0c_aWzH623r3v7FQ9EU",
  authDomain: "optmizd-bf261.firebaseapp.com",
  projectId: "optmizd-bf261",
  storageBucket: "optmizd-bf261.firebasestorage.app",
  messagingSenderId: "526044312447",
  appId: "1:526044312447:web:730a192552bb711dd9a04a",
  measurementId: "G-8JPB46JXEH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
const functions = getFunctions(app);

// Connect to emulators in development
if (window.location.hostname === 'localhost') {
  // Connect to Functions emulator on custom port
  connectFunctionsEmulator(functions, 'localhost', 5101);
  console.log('🔧 Connected to Functions Emulator on port 5101');
  
  // Note: Firestore and Auth emulators are already running on default ports
  // Only connecting to Functions emulator for email testing
}

export { app, analytics, db, auth, storage, functions };
